export enum enumDialogButtonType {
    dlgParam_Unknown = 0,
    dlgParam_Yes = 1,
    dlgParam_No = 2,
    dlgParam_Cancel = 3,
    dlgParam_OK = 4,
}

export class DialogButton {
    public buttonType: enumDialogButtonType = enumDialogButtonType.dlgParam_Unknown;
    public label: string;

    public getIcon(): string {
        var icon = "";

        switch (this.buttonType) {
            case enumDialogButtonType.dlgParam_Yes:
                icon = "fa-check";
                break;
            case enumDialogButtonType.dlgParam_No:
                icon = "fa-close";
                break;
            case enumDialogButtonType.dlgParam_Cancel:
                icon = "fa-times-circle";
                break;
            case enumDialogButtonType.dlgParam_OK:
                icon = "fa-close";
                break;
            default:
                icon = "fa-question-circle";
                break;
        }

        return icon;
    }
}